import React, { useState, useCallback, useRef } from "react";
import PropTypes from "prop-types";

import { checkCircleExist } from "./utils";
import Button from "../../components/Button";
import { Modal, ModalBody, ModalTitle } from "../../components/Modal";
import Input from "../../components/Input";

export default function AddCircleModal(props) {
  const { circles, createCircle } = props;
  const [circleName, setCircleName] = useState("");
  const [showAddCircleModal, setShowAddCircleModal] = useState(false);
  const [isCircleExist, setIsCircleExist] = useState(false);
  const cirlceNameInputRef = useRef(null);

  const closeModal = useCallback(() => {
    setShowAddCircleModal(false);
    if (isCircleExist) setIsCircleExist(false);
  }, [setShowAddCircleModal, isCircleExist]);

  const onAdd = useCallback(() => {
    if (checkCircleExist(circles, circleName)) {
      setIsCircleExist(true);
      return;
    }
    createCircle(circleName);
    closeModal();
  }, [circleName, circles, createCircle, closeModal]);

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault();
      onAdd();
    },
    [onAdd]
  );

  return (
    <>
      <Button
        onClick={(e) => {
          setShowAddCircleModal(true);
          setCircleName("");
        }}
        intent="primary"
        className="ml-1 h-10"
      >
        Add circle
      </Button>
      <Modal
        focusElement={cirlceNameInputRef}
        isOpened={showAddCircleModal}
        onClose={closeModal}
      >
        <ModalTitle>Create a new circle</ModalTitle>
        <ModalBody>
          <form onSubmit={onSubmit}>
            <div className="mb-10">
              <Input
                required
                type="text"
                value={circleName}
                onChange={(e) => {
                  if (isCircleExist) setIsCircleExist(false);
                  setCircleName(e.target.value);
                }}
                placeholder="i.e. Designers"
                innerRef={cirlceNameInputRef}
                className="h-10 w-full"
                tabIndex="-1"
              />
              {isCircleExist && (
                <p className="absolute mt-2 text-sm text-red-600">
                  <>Notice: You have already created a circle with this name</>
                </p>
              )}
            </div>
            <div className="text-right">
              <Button type="submit" intent="primary" disabled={!circleName}>
                Add
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </>
  );
}

AddCircleModal.propTypes = {
  circles: PropTypes.array.isRequired,
  createCircle: PropTypes.func.isRequired,
};
